export type ILink = {
  translationKey: string;
  label: string;
  to: string;
  imageName: string;
  buttonStyle?: 'text';
  id: string;
  Component?: JSX.Element;
};

const links: Record<string, ILink[]> = {
  'v1-nav-drawer-home-security': [
    {
      translationKey: 'home-security.home-security',
      label: 'Home Security',
      to: '/products/home-security/',
      imageName: 'cove-sensors',
      id: 'link-to-home-security',
    },
    {
      translationKey: 'home-security.alarm-panel-hub',
      label: 'Alarm Panel and Hub',
      to: '/products/alarm-panel-hub/',
      imageName: 'alarm-panel-hub',
      id: 'link-to-products-alarm-panel-hub',
    },
    {
      translationKey: 'home-security.door-sensor',
      label: 'Door Sensor',
      to: '/products/door-sensor/',
      imageName: 'door-sensor',
      id: 'link-to-products-door-sensor',
    },
    {
      translationKey: 'home-security.window-sensor',
      label: 'Window Sensor',
      to: '/products/window-sensor/',
      imageName: 'window-sensor',
      id: 'link-to-products-window-sensor',
    },
    {
      translationKey: 'home-security.motion-detector',
      label: 'Motion Detector',
      to: '/products/motion-detector/',
      imageName: 'motion-detector',
      id: 'link-to-products-motion-detector',
    },
    {
      translationKey: 'home-security.glass-break-detector',
      label: 'Glass Break Detector',
      to: '/products/glass-break-detector/',
      imageName: 'glass-break',
      id: 'link-to-products-glass-break-detector',
    },
    {
      translationKey: 'home-security.key-remote',
      label: 'Key Fob',
      to: '/products/key-remote/',
      imageName: 'key-remote',
      id: 'link-to-products-key-remote',
    },
    {
      translationKey: 'home-security.panic-button',
      label: 'Panic Button',
      to: '/products/panic-button/',
      imageName: 'medical-button',
      id: 'link-to-products-medical-alert-device',
    },
    {
      translationKey: 'home-security.siren',
      label: 'Secondary Siren',
      to: '/products/siren/',
      imageName: 'siren',
      id: 'link-to-products-siren',
    },
  ],
  'v1-nav-drawer-cameras': [
    {
      translationKey: 'cameras.cameras',
      label: 'Cameras',
      to: '/products/cameras/',
      buttonStyle: 'text',
      imageName: 'cove-cameras',
      id: 'link-to-products-cameras',
    },
    {
      translationKey: 'cameras.indoor-camera',
      label: 'Eufy Indoor Camera',
      to: '/products/indoor-camera/',
      imageName: 'indoor-camera',
      id: 'link-to-products-indoor-camera',
    },
    {
      translationKey: 'cameras.outdoor-camera',
      label: 'Eufy Outdoor Camera',
      to: '/products/outdoor-camera/',
      imageName: 'eufy-outdoor-camera',
      id: 'link-to-products-outdoor-camera',
    },
    {
      translationKey: 'cameras.doorbell-camera-eufy',
      label: 'Eufy Doorbell Camera',
      to: '/products/doorbell-camera-eufy/',
      imageName: 'eufy-doorbell-camera',
      id: 'link-to-products-doorbell-camera-eufy',
    },
  ],
  'v1-nav-drawer-environmental': [
    {
      translationKey: 'environmental-detectors.environmental-detectors',
      label: 'Environmental Detectors',
      to: '/environmental/',
      buttonStyle: 'text',
      imageName: 'environmental-detectors',
      id: 'link-to-products-environmental',
    },
    {
      translationKey: 'environmental-detectors.smoke-detector',
      label: 'Smoke Detector',
      to: '/products/smoke-detector/',
      imageName: 'smoke-carbon',
      id: 'link-to-products-smoke-co',
    },
    {
      translationKey: 'environmental-detectors.co-detector',
      label: 'Carbon Monoxide',
      to: '/products/co-detector/',
      imageName: 'co-detector',
      id: 'link-to-products-co-detector',
    },
    {
      translationKey: 'environmental-detectors.flood-sensor',
      label: 'Water Leak Detector',
      to: '/products/flood-sensor/',
      imageName: 'flood-sensor',
      id: 'link-to-products-freeze-detector',
    },
  ],
  'v1-nav-drawer-services': [
    {
      translationKey: 'services.professional-installation',
      label: 'Professional Installation',
      to: '/professional-installation/',
      buttonStyle: 'text',
      imageName: 'installing-sensor',
      id: 'link-to-professional-installation',
    },
    {
      translationKey: 'services.monitored-security',
      label: 'Monitoring',
      to: '/monitored-security/',
      imageName: 'installing-sensor',
      id: 'link-to-monitored-security',
    },
  ],
  'v1-nav-drawer-contact': [
    {
      translationKey: 'help.phone-number',
      label: '855.268.3669',
      to: 'tel:8552683669',
      imageName: '',
      id: 'link-to-call-cove',
    },
    {
      translationKey: 'help.chat',
      id: 'chat',
      label: 'Chat',
      to: '',
      imageName: '',
    },
  ],
};

export { links };
